var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 66,
    viewBox: "0 0 198 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    clipPath: "url(#clip0_357_204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.927 52.1084H5.48857C2.45731 52.1084 0 54.5765 0 57.621V60.4876C0 63.5321 2.45731 66.0002 5.48857 66.0002H157.927C160.958 66.0002 163.415 63.5321 163.415 60.4876V57.621C163.415 54.5765 160.958 52.1084 157.927 52.1084Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.222 26.0542H22.7844C19.7532 26.0542 17.2958 28.5223 17.2958 31.5668V34.4334C17.2958 37.4779 19.7532 39.946 22.7844 39.946H175.222C178.254 39.946 180.711 37.4779 180.711 34.4334V31.5668C180.711 28.5223 178.254 26.0542 175.222 26.0542Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.511 0H40.0734C37.0422 0 34.5848 2.46809 34.5848 5.51263V8.3792C34.5848 11.4237 37.0422 13.8918 40.0734 13.8918H192.511C195.543 13.8918 198 11.4237 198 8.3792V5.51263C198 2.46809 195.543 0 192.511 0Z",
    fill: "#9AD5EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame7);
export default __webpack_public_path__ + "static/media/frame-7.cb9fc0c47138973257db71d8f438f3c9.svg";
export { ForwardRef as ReactComponent };